import { render, staticRenderFns } from "./RequerAtencao.vue?vue&type=template&id=134bf31d"
import script from "./RequerAtencao.vue?vue&type=script&lang=js"
export * from "./RequerAtencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports